var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "modal-header" }, [
      _c("h3", { staticClass: "modal-title" }, [
        _c("span", [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function ($event) {
                return _vm.modal.dismiss()
              },
            },
          },
          [
            _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")]),
            _c("span", { staticClass: "sr-only" }, [_vm._v("Close")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "modal-bottom bg-white w-100 flex-center-center flex-column pos-sticky bottom-0 zindex-1 radius-18 px-10 py-10 shadow-4",
        },
        [
          _c("div", { attrs: { xclass: "d-flex flex-start-center" } }, [
            _c("div", { staticClass: "catalogList--items container" }, [
              _c(
                "div",
                {
                  staticClass: "productItemBloc border-bottom-bo-grey5",
                  attrs: { id: "viewGrid" },
                },
                [
                  _c(
                    "ul",
                    { staticClass: "grid-container" },
                    _vm._l(_vm.selected, function (child) {
                      return _c(
                        "li",
                        {
                          key: child.id,
                          staticClass: "catalogList--item cursor-pointer",
                        },
                        [
                          _c("ProductItem", {
                            attrs: { child: child, "image-only": true },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "btnFlat-color2 my-10 mx-10 flex-1 fsize-18 shadow-1",
              class: { disabled: !_vm.selected.length },
              attrs: { disabled: !_vm.selected.length },
              on: {
                click: function ($event) {
                  return _vm.useImages()
                },
              },
            },
            [
              _c("span", [
                !_vm.selected.length
                  ? _c(
                      "span",
                      {
                        staticStyle: { margin: "0", "text-transform": "none" },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.title))])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected.length
                  ? _c(
                      "span",
                      {
                        staticStyle: { margin: "0", "text-transform": "none" },
                      },
                      [_vm._v("Utiliser " + _vm._s(_vm.selected[0].product.dn))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected.length == 2
                  ? _c(
                      "span",
                      {
                        staticStyle: { margin: "0", "text-transform": "none" },
                      },
                      [
                        _vm._v(
                          "et " + _vm._s(_vm.selected.length - 1) + " autre"
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected.length > 2
                  ? _c(
                      "span",
                      {
                        staticStyle: { margin: "0", "text-transform": "none" },
                      },
                      [
                        _vm._v(
                          "et " + _vm._s(_vm.selected.length - 1) + " autres"
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("i", { staticClass: "fie-icon_arrow2-r" }),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _vm.treeItem
          ? _c("TreePath", {
              staticStyle: { display: "inline-block", width: "100%" },
              attrs: { item: _vm.treeItem },
              on: { "set-current": _vm.setCurrent },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "catalogList--items container p-20" }, [
          _c(
            "div",
            {
              staticClass: "productItemBloc border-bottom-bo-grey5 pb-50 mb-20",
              attrs: { id: "viewGrid" },
            },
            [
              _vm.treeItem
                ? _c(
                    "ul",
                    { staticClass: "grid-container" },
                    _vm._l(_vm.treeItem.childs, function (child) {
                      return _c(
                        "li",
                        {
                          key: child.id,
                          staticClass: "catalogList--item cursor-pointer",
                          class: {
                            "border-2-bo-success": _vm.isSelected(child),
                            "xopacity-03": !_vm.canSelect(child),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.select(child)
                            },
                          },
                        },
                        [
                          _c("ProductItem", {
                            attrs: { child: child, "read-only": true },
                            on: { "set-current": _vm.setCurrent },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c(
                    "ul",
                    { staticClass: "grid-container flex-around-center" },
                    [_vm._m(0)]
                  ),
            ]
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "div",
        {
          staticClass:
            "modal-bottom bg-white w-100 flex-center-center pos-sticky bottom-0 zindex-1 radius-18 px-10 py-10 shadow-4",
        },
        [
          _c(
            "button",
            {
              staticClass:
                "btnFlat-color2 my-10 mx-10 flex-1 fsize-18 shadow-1",
              class: { disabled: !_vm.selected.length },
              attrs: { disabled: !_vm.selected.length },
              on: {
                click: function ($event) {
                  return _vm.useImages()
                },
              },
            },
            [
              _c("span", [
                !_vm.selected.length
                  ? _c(
                      "span",
                      {
                        staticStyle: { margin: "0", "text-transform": "none" },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.title))])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected.length
                  ? _c(
                      "span",
                      {
                        staticStyle: { margin: "0", "text-transform": "none" },
                      },
                      [_vm._v("Utiliser " + _vm._s(_vm.selected[0].product.dn))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected.length == 2
                  ? _c(
                      "span",
                      {
                        staticStyle: { margin: "0", "text-transform": "none" },
                      },
                      [
                        _vm._v(
                          "et " + _vm._s(_vm.selected.length - 1) + " autre"
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected.length > 2
                  ? _c(
                      "span",
                      {
                        staticStyle: { margin: "0", "text-transform": "none" },
                      },
                      [
                        _vm._v(
                          "et " + _vm._s(_vm.selected.length - 1) + " autres"
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("i", { staticClass: "fie-icon_arrow2-r" }),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Chargement des images "),
      _c("i", { staticClass: "loading" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }